import Vue from 'vue'
import { stat } from 'fs'

export default {
  namespaced: true,

  state: {
    items: []
  },

  getters: {
    items: state => {
        return state.items
    }
  },

  mutations: {
    setItems (currentState, items) {
        currentState.items = items
    },
    addItem (currentState, {index, item}) {
        let cut = currentState.items.length

        let prompt = item || {cut: cut, name: '', text:'',word_count:0, saved: false, amount: 0, open: false, extra_words_fee: 0}

        currentState.items.push(prompt)
    },
    updateItem (currentState, {item, index}) {
        if (typeof index !== 'undefined') {
            return Vue.set(currentState.items, index, item)
        }


        for (var i = 0; i < currentState.items.length; i++) {
            if (currentState.items[i].id === item.id) {
                Vue.set(currentState.items, i, item)
            }
        }
    },
    removeItem (currentState, index) {
        currentState.items.splice(index, 1)
        
        if (currentState.items.length === 0) {
            currentState.items.push({cut: 0, name: '', text:'',word_count:0, saved: false, amount: 0, open: false, extra_words_fee: 0})
        }
    },
    clear (currentState) {
        currentState.items = []
    }
  },

  actions: {
    create: ({dispatch, commit, state}, {data, index}) => {
        dispatch('startCalculate', null, { root: true })
        let uri = '/prompts'
        return new Promise((resolve, reject) => {
            Vue.axios.post(uri, data)
                .then(res => {
                    commit('updateItem', {item: res.data, index: index})
                    resolve(res.data)
                    dispatch('finishCalculate', null, { root: true })
                })
                .catch(err => {
                    console.log(err)
                })
        })
    },
    read: (context, id) => {
        let uri = '/prompts/' + id
        return new Promise((resolve, reject) => {
            Vue.axios.get(uri)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
          })
    },
    update: ({dispatch, commit, state}, {data, index}) => {
        dispatch('startCalculate', null, { root: true })
        let uri = '/prompts/' + data.id

        return new Promise((resolve, reject) => {
            Vue.axios.put(uri, data)
                .then(res => {
                    commit('updateItem', {item: res.data, index: index})
                    resolve(res.data)
                    dispatch('finishCalculate', null, { root: true })
                })
                .catch(err => {
                    console.log(err)
                })
        })
    },
    delete: ({commit, state}, {id, index}) => {
        if (id === 0) {
            return commit('removeItem', index)
        }

        let uri = '/prompts/' + id

        return new Promise((resolve, reject) => {
            Vue.axios.delete(uri)
                .then(res => {
                    commit('removeItem', index)

                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
        })
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./prompts/store/modules/Prompt.js
// module id = null
// module chunks = 